define('GameDayCore/GDModel/ValueObjects/Players/PlayerCard',['require','exports','module','message-service/message-service','extant/extant','../ValueObjectFactory','./PlayerCardSplits','ensureArray/ensureArray'],function(require, exports, module) {
    var MessageService = require("message-service/message-service"),
        exists = require("extant/extant"),
        VO = require('../ValueObjectFactory'),
        SplitsVO = require("./PlayerCardSplits"),
        ensureArray = require('ensureArray/ensureArray');

    VO.create(PlayerCard);

    /**
     * Class PlayerCard
     * @param $data the json-ed XML from the PlayerCard file
     *
     * a VO to parse data out of the player card xml file and present in a guaranteed model
     */
    function PlayerCard($data) {
        var
            vo = VO.ensureVO(this, PlayerCard),
            data = $data,
            gameModel = GameModelLocator.getCurrentGame(),
            playerSnap = gameModel.getPlayerSnapshot(data.id, data.type.substr(0, 1)),
            boxpos = parsePosition(data.type),
            atbats = [],
            splits = [],
            splitsHash = {},
            faced = [],
            loveHate = {};

        vo.team = data.team || "";
        vo.id = data.id || "";
        vo.pid = data.id || "";
        vo.pos = data.pos || "";
        vo.type = data.type || "";
        vo.b_or_p = data.type || "";
        vo.first_name = data.first_name || "";
        vo.last_name = data.last_name || "";
        vo.full_name = (data.first_name || "") + " " + (data.last_name || "");
        vo.jersey_number = data.jersey_number || "";
        vo.height = data.height || "";
        vo.weight = data.weight || "";
        vo.bats = parseBatsWith();
        vo.throwsWith = parseThrowsWith();
        vo.dob = data.dob || "";
        vo.loves = loveHate.loves || "";
        vo.hates = loveHate.hates || "";
        //
        vo.boxpos = boxpos;
        vo.splits = splits;
        vo.splitsHash = splitsHash;
        vo.faced = faced;
        vo.atbats = atbats;
        vo.getSplits = function ($enum) {
            return splitsHash[$enum.toLowerCase()]
        };
    }

    function parsePosition($pos) {
        if ($pos === "batter") {
            if (exists(playerSnap.pos)) {
                if (playerSnap.pos.indexOf("-") != -1) {
                    var pos_result = playerSnap.pos.split("-");
                    boxpos = pos_result[pos_result.length - 1];
                } else {
                    boxpos = playerSnap.pos;
                }
            } else {
                boxpos = data.pos;
            }
        } else {
            boxpos = "P";
        }
    }

    function parseThrowsWith() {
        var throwing = data.throws || undefined;

        if (exists(throwing)) {
            return (throwing === "R") ? "Right" : (throwing === "L") ? "Left" : "Switch";
        }

        return "";
    }

    function parseBatsWith() {
        var batting = data.bats || undefined
        if (exists(batting)) {
            return (batting === "R") ? "Right" : (batting === "L") ? "Left" : "Switch";
        }

        return "";
    }

    // splits logic goes here
    function buildSplitsObj() {
        for (var i = 0, long = data._childList.length; i < long; i++) {
            var splitsObj = data._childList.get(i);

            switch (splitsObj._nodeName) {
                case "faced":
                    processPitchTypes(splitsObj);
                    break;

                case "atbats":
                    parseAtbats(splitsObj);
                    break;

                case "Pitch":
                    loveHate.loves = splitsObj.loves;
                    loveHate.hates = splitsObj.hates;
                    break;

                default:
                    processSplitData(splitsObj);
                    break;
            }

            return splitsObj
        }
    }

    function processPitchTypes($faced) {
        // null check
        if (!exists($faced) || !exists($faced.pitch)) {
            return;
        }

        var pitchesArray = ensureArray($faced.pitch);

        for (var i = 0; i < pitchesArray.length; i++) {
            //strip out the top level, leaving only pitch types on the array
            pitchesArray[i] = pitchesArray[i].type;
        }

        faced = faced.concat(pitchesArray);
    }

    function parseAtbats(atbats) {
        var abs = []
        if ((exists(atbats, "ab"))) {
            abs = ensureArray(atbats.ab).reverse();
        }

        atbats = atbats.concat(abs);
    }

    function processSplitData($splitData) {
        var split_o = new SplitsVO($splitData);

        switch (split_o.name) {
            // in regular season splits1 == career
            // in postseason, splits1 == series to date
            case "career":
            case "series":
                //show career or series only if its specified in the skin config
                if (GDAppDataConfigModel.pc_splits == "cs") {
                    switch (gameModel.getGameFileVO().type.toLowerCase()) {
                        case "d":
                        case "l":
                        case "w":
                            var series_label = (!split_o.des) ? "This Series" : split_o.des;
                            split_o.label = series_label;
                            break;
                        default:
                            split_o.label = "Career";
                            break;
                    }
                    splits[1] = split_o;
                } else {
                    splits[1] = {label: "", ab: "", avg: "", hr: "", rbi: "", ops: "", bb: "", so: ""};
                }
                break;

            case "season":
                split_o.label = "Season";
                splits[2] = split_o;
                break;

            case "month":
            case "Month":
                split_o.label = split_o.des;
                splits[3] = split_o;
                break;

            case "Team":
                split_o.label = split_o.des;
                splits[4] = split_o;
                break;

            case "vs_LHP":
            case "vs_RHP":
            case "vs_LHB":
            case "vs_RHB":
                if (data.type === "batter") {
                    if (gameModel.getPlaysFileVO().batter_splits == split_o.name) {
                        splits[5] = split_o;
                    }
                } else if (data.type === "pitcher") {
                    if (gameModel.getPlaysFileVO().pitcher_splits == split_o.name) {
                        splits[5] = split_o;
                    }
                }
                break;

            case "Men_On":
                if (gameModel.getPlaysFileVO().mob_splits == split_o.name) {
                    split_o.label = "Runners On";
                    splits[6] = split_o;
                }
                break;

            case "Empty":
            case "RISP":
            case "Loaded":
                if (gameModel.getPlaysFileVO().mob_splits == split_o.name) {
                    splits[6] = split_o;
                }
                break;

            case "vs_P":
            case "vs_B":
                split_o.label = "vs " + split_o.des;
                splits[7] = split_o;
                break;

            case "vs_P5":
            case "vs_B5":
                split_o.label = "vs " + split_o.des;
                splits[8] = split_o;
                break;
        }

        splitsHash[split_o.name.toLowerCase()] = split_o;
    }
    
    return PlayerCard;
});

